import DemoSection from '../DemoSection';
import { UILoading } from '../WebComponents';

export default function LoadingDemo() {
  return (
    <DemoSection title="Loading 加载中" description="页面局部处于等待异步数据或正在渲染过程时">
      <DemoSection.Item title="尺寸">
        <div className="demo-content">
          <UILoading size="small" />
          <UILoading size="medium" />
          <UILoading size="large" />
        </div>
        <div className="code-block">
          <code>{`<UILoading size="small" />
<UILoading size="medium" />
<UILoading size="large" />`}</code>
        </div>
      </DemoSection.Item>

      <DemoSection.Item title="带文字">
        <div className="demo-content">
          <UILoading size="medium" text="加载中..." />
        </div>
        <div className="code-block">
          <code>{`<UILoading size="medium" text="加载中..." />`}</code>
        </div>
      </DemoSection.Item>
    </DemoSection>
  );
}
